import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Plus } from "lucide-react";

const blank = { name: "", type: "flight_school", phone: "", email: "", website: "", logo_url: "", programs: "", description: "" };

export default function AdminFlightSchools() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);

  const load = () => api.get("/flight-schools").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    const payload = { ...form, programs: form.programs.split(",").map((s) => s.trim()).filter(Boolean) };
    await api.post("/flight-schools", payload);
    setForm(blank);
    load();
  };
  const del = async (id) => { await api.delete(`/flight-schools/${id}`); load(); };
  const setType = async (s, newType) => {
    await api.put(`/flight-schools/${s.id}`, { ...s, type: newType });
    load();
  };

  return (
    <div data-testid="admin-schools">
      <div className="section-label">Directory</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Organizations & Flight Schools</h1>

      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-md grid sm:grid-cols-2 gap-3">
        <input data-testid="school-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <select data-testid="school-type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="border border-slate-300 px-3 py-2 bg-white">
          <option value="flight_school">Flight School</option>
          <option value="organization">Other Organization</option>
        </select>
        <input data-testid="school-phone" placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="school-email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="school-website" placeholder="Website" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <input data-testid="school-logo" placeholder="Logo URL (optional)" value={form.logo_url} onChange={(e) => setForm({ ...form, logo_url: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <input data-testid="school-programs" placeholder="Programs (comma separated)" value={form.programs} onChange={(e) => setForm({ ...form, programs: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <textarea data-testid="school-desc" placeholder="Description" rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <button data-testid="school-add" onClick={add} className="bg-slate-950 text-white px-4 py-2 sm:col-span-2 inline-flex items-center gap-2 justify-center"><Plus className="h-4 w-4" /> Add entry</button>
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-4">
        {list.map((s) => (
          <div key={s.id} className="bg-white border border-slate-200 p-5 rounded-md">
            <div className="flex justify-between items-start gap-3">
              <div>
                <div className="font-display text-lg font-semibold">{s.name}</div>
                <div className="text-[11px] font-mono uppercase tracking-widest text-sky-600 mt-1">
                  {(s.type || "flight_school") === "flight_school" ? "Flight School" : "Organization"}
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <button
                  onClick={() => setType(s, (s.type || "flight_school") === "flight_school" ? "organization" : "flight_school")}
                  className="text-[10px] font-mono uppercase tracking-widest border border-slate-300 px-2 py-1 hover:border-slate-950"
                  title="Toggle type"
                >
                  Switch
                </button>
                <button data-testid={`school-del-${s.id}`} onClick={() => del(s.id)} className="text-red-600 hover:text-red-800"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            <div className="text-xs font-mono text-slate-500 mt-2">{s.phone} · {s.email}</div>
            {s.description && <p className="text-sm text-slate-600 mt-2">{s.description}</p>}
            {Array.isArray(s.programs) && s.programs.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1">
                {s.programs.map((p) => <span key={p} className="text-[11px] font-mono uppercase border border-slate-300 px-2 py-0.5">{p}</span>)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
